import {addMongoUser, addUser} from "../redux/slices/userSlice";
import store from '../redux/store'
import Config from '../config'
import moment from 'moment'


const functions = {
  updateUserStore: function (firebaseUser) {
    if (firebaseUser) {
      store.dispatch(addUser({
        email: firebaseUser.email,
        uid: firebaseUser.uid
      }))
    }
  },

	getFormattedNumber: function (number) {
		if(number === undefined || number === null || number === 0 || isNaN(number)) return '0.00'
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},

  updateMongoUserStore: function (user) {
    if (user) {
      store.dispatch(addMongoUser(user))
    }
  },

	isEmptyAndNaN: function (value) {
		return value === null || value === undefined || value === '' || isNaN(value);
	},

  numFormatter: function (num) {
    if (isNaN(num)) return null
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
  },

  validateEmail: function (email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  },

	calculateMonthlyPayment: function(principal, annualInterestRate, termInMonths) {
		// Convert annual interest rate to monthly interest rate
		const monthlyInterestRate = annualInterestRate / 12;



		// Apply the loan payment formula
		const monthlyPayment =
			principal *
			(monthlyInterestRate * Math.pow((1 + monthlyInterestRate), termInMonths)) /
			(Math.pow((1 + monthlyInterestRate), termInMonths) - 1);

		return monthlyPayment;
	},

	checkIfNumber: function(text) {
		const re = /^-?\d*(\.\d*)?$/
		return text === '' || re.test(text)
	},

	calcPresentValueAnnuity: function(amount, apr, months) {
		if(!amount || !apr)
			return 0
		let toReturn = (-amount * (1 - Math.pow(1 + apr / 1200, months))) / (apr / 1200)
		return Number(toReturn.toFixed(2))
	},

	PMT: function(ir, np, pv, fv, type) {
		/*
		 * ir   - interest rate per month
		 * np   - number of periods (months)
		 * pv   - present value
		 * fv   - future value
		 * type - when the payments are due:
		 *        0: end of the period, e.g. end of month (default)
		 *        1: beginning of period
		 */
		let pmt, pvif;

		fv || (fv = 0);
		type || (type = 0);

		if (ir === 0)
			return -(pv + fv)/np;

		pvif = Math.pow(1 + ir, np);
		pmt = - ir * (pv * pvif + fv) / (pvif - 1);

		if (type === 1)
			pmt /= (1 + ir);

		return pmt;
	}





}

export default functions
